import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { DatabaseLineageCountsFragmentGql } from './DatabaseLineageCountsFragmentGql';

export const DatabaseLineageCountsQueryGql: DocumentNode = gql`
query DatabaseLineageCountsQuery($databaseId: ID!, $publishedConnectionsLineageEnabled: Boolean!) {
  databases(filter: { id: $databaseId }) {
    ...DatabaseLineageCountsFragment
  }
}
${DatabaseLineageCountsFragmentGql}
`;
